/// <amd-module name="Dashboards/CommonConfig/SizePickerHelpers" />
import * as Resources from "Dashboards/CommonConfig/Resources";
import { WidgetGridSize } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import { format } from "VSS/Core/Util/String";
import { IListBoxItem } from "VSSUI/ListBox";

export function getSizeOptionsMap(sizes: WidgetGridSize[]): { [key: string]: string[] } {
    const widthToHeightsMap: { [key: string]: string[] } = {};
    for (const size of sizes) {
        const width = size.columnSpan.toLocaleString();
        const height = size.rowSpan.toLocaleString();
        if (widthToHeightsMap[width]) {
            if (widthToHeightsMap[width].indexOf(height) !== -1) {
                throw new Error(Resources.DuplicateWidgetSizesError);
            }
            widthToHeightsMap[width].push(height);
        } else {
            widthToHeightsMap[width] = [height];
        }
    }
    for (const width in widthToHeightsMap) {
        if (widthToHeightsMap.hasOwnProperty(width)) {
            widthToHeightsMap[width].sort((x, y) => +x - +y); // Sort just in case
        }
    }
    return widthToHeightsMap;
}

export function generateOptions(sizes: WidgetGridSize[]): IListBoxItem[] {
    return sizes.map((size: WidgetGridSize, id: number) => {
        const text = format(Resources.Size_ColumnXRow, size.columnSpan, size.rowSpan);
        return {
            id: text,
            text: text
        } as IListBoxItem;
    });
}

export function hasRectangularOptionsSet(widthToHeightsMap: { [key: string]: string[] }): boolean {
    const widths = Object.keys(widthToHeightsMap);
    const baseAvailableHeights = widthToHeightsMap[widths[0]];
    let isRectangularDataShape = true;
    for (const width in widthToHeightsMap) {
        if (widthToHeightsMap.hasOwnProperty(width)) {
            const heights = widthToHeightsMap[width];
            if (heights.length !== baseAvailableHeights.length || !heights.every((value, index) => value === baseAvailableHeights[index])) {
                isRectangularDataShape = false;
                break;
            }
        }
    }
    return isRectangularDataShape;
}
